// VisionMission.jsx
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { TextField, Button } from "@mui/material";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { server } from "../common";
import * as Yup from "yup";

const VisionMission = () => {
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = (item) => {
    setSelected(item);
    formik.setValues({
      description: item.description || "",
      image: null,
    });
    setShow(true);
  };

  const getData = () => {
    server
      .get("/gallery/getvisionmission")
      .then((res) => setData(res.data || []))
      .catch(() => toast.error("Failed to load data"));
  };

  useEffect(() => {
    getData();
  }, []);

  const formik = useFormik({
    initialValues: {
      description: "",
      image: null,
    },
    enableReinitialize: false,
    validationSchema: Yup.object({
      description: Yup.string().required("Description is required"),
    }),
    onSubmit: (values) => {
      if (!selected?.type) {
        toast.error("Invalid selection");
        return;
      }

      const formData = new FormData();
      formData.append("description", values.description);
      if (values.image) formData.append("image", values.image);

      server
        .put(`/gallery/update/${selected.type}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          toast.success(`${selected.type} updated successfully`);
          handleClose();
          getData();
        })
        .catch(() => toast.error("Update failed"));
    },
  });

  return (
    <div className="container py-4">
      <h3 className="text-center mb-4">Vision & Mission</h3>
      <div className="row">
        {data.map((item) => (
          <div className="col-md-6 mb-4" key={item.id}>
            <div className="card shadow-lg rounded-3 p-3">
              <h4 className="text-capitalize">{item.type}</h4>
              <p>{item.description}</p>
              {item.image && (
                <img
                  src={item.image}
                  alt={item.type}
                  className="img-fluid rounded"
                  style={{ maxHeight: "250px", objectFit: "cover" }}
                />
              )}
              <Button
                variant="contained"
                color="info"
                className="mt-2"
                onClick={() => handleShow(item)}
              >
                Update {item.type}
              </Button>
            </div>
          </div>
        ))}
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update {selected?.type}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formik.handleSubmit}>
            <div className="mb-3">
              <TextField
                name="description"
                label="Description"
                value={formik.values.description}
                onChange={formik.handleChange}
                multiline
                rows={4}
                fullWidth
              />
              {formik.errors.description && (
                <p className="text-danger">{formik.errors.description}</p>
              )}
            </div>

            <div className="mb-3">
              <input
                type="file"
                accept="image/*"
                onChange={(e) =>
                  formik.setFieldValue("image", e.currentTarget.files[0])
                }
              />
              {selected?.image && (
                <div className="mt-2">
                  <p className="mb-1">Current Image:</p>
                  <img
                    src={selected.image}
                    alt="current"
                    style={{
                      width: "120px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              )}
            </div>

            <Button type="submit" variant="contained" color="success">
              Update
            </Button>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default VisionMission;
